angular
  .module('fca-used')
  .component('gallery', {
    require: {
      vehicleDetailsController: '?^^vehicleDetails',
      vehiclePreviewController: '?^^vehiclePreview'
    },
    templateUrl: 'app/gallery/gallery.html',
    controller: galleryController,
    controllerAs: 'gallery'
  });

galleryController.$inject = ['$http', 'CONFIG'];

function galleryController($http, CONFIG) {
  var gallery = this;
  gallery.basePath = CONFIG.uvl.images;

  gallery.$onInit = function () {
    if (gallery.vehicleDetailsController) {
      gallery.data = gallery.vehicleDetailsController.data;
      gallery.toggleWishlist = gallery.vehicleDetailsController.toggleWishlist;
    } else if (gallery.vehiclePreviewController) {
      gallery.data = gallery.vehiclePreviewController.data;
      gallery.toggleWishlist = gallery.vehiclePreviewController.toggleWishlist;
    }
    selectDefaultPicture();
  };

  function cacheImages() {
    var l = gallery.data.assets.length;
    var next = ++gallery.current % gallery.data.assets.length;
    var prev = ((--gallery.current % l) + l) % l;
    var size = gallery.fullscreen ? 'source' : 'medium';

    $http.get(gallery.basePath + gallery.data.assets[next][size]);
    $http.get(gallery.basePath + gallery.data.assets[prev][size]);
  }

  gallery.next = function () {
    gallery.current = ++gallery.current % gallery.data.assets.length;
    cacheImages();
  };

  gallery.prev = function () {
    var l = gallery.data.assets.length;
    gallery.current = ((--gallery.current % l) + l) % l;
    cacheImages();
  };

  function selectDefaultPicture() {
    gallery.current = 0;
    for (var i = 0; i < gallery.data.assets.length && !gallery.current; i++) {
      if (gallery.data.assets[i].isDefault) {
        gallery.current = i;
      }
    }
    cacheImages();
  }
}
